<template>
  <div>
    <loader :show="isLoading" :width="40" :height="40"></loader>
    <div v-for="item in options" :key="item.name" class="custom-control custom-checkbox form-check">
      <input
        type="checkbox"
        class="custom-control-input form-check-input"
        :id="item.slug"
        :value="item"
        v-model="categories"
        @change="notify"
      />
      <label class="custom-control-label form-check-label" :for="item.slug">{{item.name}}</label>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  name: "CategoryCombo",
  data() {
    return {
      categories: [],
      options: [],
      isLoading: true
    };
  },

  props: {
    mainCategory: {
      type: Number,
      default: -1
    },
    value: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    value: function(v1, v2) {
      if (v1 == v2) return;
      this.validateInput(this.value);
    },
    mainCategory: function() {
      this.validateInput(this.value);
      this.loadMainCategory();
    }
  },

  methods: {
    notify: function() {
      this.$emit("input", this.categories);
      this.$emit("change", this.categories);
    },
    validateInput: function(input) {
      var self = this;
      if (this.options.length > 0) {
        var mapCat = _.map(input, function(item) {
          let index = _.findIndex(self.options, function(o) {
            return o.id == item.id;
          });
          if (index >= 0) {
            return self.options[index];
          } else {
            return null;
          }
        });
        this.$set(
          this,
          "categories",
          _.filter(mapCat, function(cat) {
            return cat !== null;
          })
        );
      }
    },
    loadMainCategory() {
      //passo alle variabili data i contenuti ricevuti in input
      //recupero elenco target
      var self = this;
      self.isLoading = true;
      self.options = [];
      if( this.mainCategory < 0 ){
        self.isLoading = false;
        return;
      }
      axios({
        method: "get",
        url:
          self.$url +
          "operations/categories?main=" +
          this.mainCategory +
          "&lang=" +
          self.$config.getLanguage(),
        headers: this.$config.axiosHeaders()
      })
        .then(function(response) {
          var obj = response.data.data;
          self.$set(self, "options", obj);
          self.validateInput(self.value);
          self.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          self.options = [];
          self.isLoading = false;
        });
    }
  },

  created() {
    this.loadMainCategory();
  }
}; // export
</script>
